import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {

    menuItems: Array<any>;
    subscribermenuItems: Array<any>;
    consumermenuItems: Array<any>;

    constructor() {
        this.menuItems = [];
        this.subscribermenuItems = [];
        this.consumermenuItems = [];

    }

    addMenu(items: Array<{
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>
    }>) {
        items.forEach((item) => {
            this.menuItems.push(item);
        });
    }

    addNewMenu(subscriberitems: Array<{
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>
    }>) {
        subscriberitems.forEach((subscriberitems) => {
            this.subscribermenuItems.push(subscriberitems);
        });
    }
    addConsumerMenu(consumeritems: Array<{
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>
    }>) {
        this.consumermenuItems = [];

        if (consumeritems.length != 0){
            consumeritems.forEach((consumeritems) => {
                this.consumermenuItems.push(consumeritems);
            });
        }
        else{
            this.consumermenuItems.push(consumeritems);
        }

    }

    getMenu() {
        return this.menuItems;
    }

    getNewMenu() {
        return this.subscribermenuItems;
    }

    getConsumerMenu() {
        return this.consumermenuItems;
    }

}
